import React from 'react'
import { Input } from 'components/inputs'
import { FilterOptions } from './filterOptions'

export const StringFilter = ({ localize, column, update, classes }) => {
  const { option } = column
  const showInput = option.id !== 'isempty' && option.id !== 'isnotempty'
  const handleOnChange = React.useCallback((value) => update({ value }), [update])
  return (
    <div>
      <FilterOptions localize={localize} classes={classes} column={column} update={update} />
      {showInput && <Input value={column.value} onChange={handleOnChange} />}
    </div>
  )
}